export default "__VITE_ASSET__p_d1eEZ7__"